import { tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';

import { SgLogglyTracker, SgHttpErrorLogRecord } from './loggly.service';
import { HttpErrorLog } from './log-interface';

/**
 * A Global HTTP error handler that act's as a bridge to loggly.
 */
@Injectable()
export class SgHttpLoggingInterceptor implements HttpInterceptor {
  constructor(private logger: SgLogglyTracker) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const start = Date.now();
    let ok: string;

    // extend server response observable with logging
    return next.handle(req).pipe(
      tap(undefined, (error) => {
        const httpErrorLog: HttpErrorLog = req.body;
        if (httpErrorLog && httpErrorLog.ApplicationId && httpErrorLog.errorSource === 'httpError') {
          // prevent recursive log attempts.
          // if the body is a previous error log attempt, calling it again will result in another error. Probably there is no connection.
          return;
        }

        const errorInfo: SgHttpErrorLogRecord = {
          error,
          req,
          time: { start, end: Date.now() },
        };
        this.logger.httpError(errorInfo);
      })
    );
  }
}
